import { AlarmEffects } from '@app/modules/core/effects/alarm.effects';
import { CountryDepartmentEffects } from '@app/modules/core/effects/country-department.effects';
import { DestinationEffects } from '@app/modules/core/effects/destination.effects';
import { FollowGroupEffects } from '@app/modules/core/effects/follow-group.effects';
import { HangerEffects } from '@app/modules/core/effects/hanger.effects';
import { LogsEffects } from '@app/modules/core/effects/logs.effects';
import { MilestoneEffects } from '@app/modules/core/effects/milestone.effects';
import { NotificationEffects } from '@app/modules/core/effects/notification.effects';
import { ProformaEffects } from '@app/modules/core/effects/proforma.effects';
import { ReportsEffects } from '@app/modules/core/effects/reports.effects';
import { RuleEffects } from '@app/modules/core/effects/rule.effects';
import { ShippingmarksEffects } from '@app/modules/core/effects/shippingmarks.effects';
import { ShowroomEffects } from '@app/modules/showroom/effects/showroom.effects';
import { AuthEffects } from '@core/effects/auth.effects';
import { AutocompleteEffects } from '@core/effects/autocomplete.effects';
import { BrandEffects } from '@core/effects/brand.effects';
import { BriefEffects } from '@core/effects/brief.effects';
import { BusinessUnitEffects } from '@core/effects/business-unit.effects';
import { ColorBusinessEffects } from '@core/effects/color-bussiness.effects';
import { ColorEffects } from '@core/effects/color.effects';
import { CommentEffects } from '@core/effects/comment.effects';
import { CountryEffects } from '@core/effects/country.effects';
import { CoverEffects } from '@core/effects/cover.effects';
import { DepartamentsBusinessColorEffects } from '@core/effects/departaments-business-color.effects';
import { DepartmentFoodEffects } from '@core/effects/department-food.effects';
import { DepartmentEffects } from '@core/effects/department.effects';
import { DestinationCenterEffects } from '@core/effects/destination-center.effects';
import { FileEffects } from '@core/effects/file.effects';
import { FollowArrivalEffects } from '@core/effects/follow-arrival.effects';
import { FollowCountryEffects } from '@core/effects/follow-country.effects';
import { FollowShipmentEffects } from '@core/effects/follow-shipment.effects';
import { FollowEffects } from '@core/effects/follow.effects';
import { JobEffects } from '@core/effects/job.effects';
import { ManagementEffects } from '@core/effects/management.effects';
import { MemberEffects } from '@core/effects/member.effects';
import { PackagingEffects } from '@core/effects/packaging.effects';
import { PackagingManagerEffects } from '@core/effects/packaging-manager.effects';
import { PlannerIdEffects } from '@core/effects/planner-id.effects';
import { PortEffects } from '@core/effects/port.effects';
import { ProductArrivalEffects } from '@core/effects/product-arrival.effects';
import { ProductCountryEffects } from '@core/effects/product-country.effects';
import { ProductShipmentEffects } from '@core/effects/product-shipment.effects';
import { ProductEffects } from '@core/effects/product.effects';
import { ProviderEffects } from '@core/effects/provider.effects';
import { RetroplanningEffects } from '@core/effects/retroplaning.effects';
import { SarEffects } from '@core/effects/sar_state.effects';
import { SeasonEffects } from '@core/effects/season.effects';
import { ShipmentEffects } from '@core/effects/shipment.effect';
import { ShippingTimeEffects } from '@core/effects/shipping-time.effects';
import { SustainabilityEffects } from '@core/effects/sustainability.effects';
import { UserBusinessEffects } from '@core/effects/user-business.effects';
import { UserEffects } from '@core/effects/user.effects';


export const effects = [
  AutocompleteEffects,
  AuthEffects,
  BrandEffects,
  FollowCountryEffects,
  BusinessUnitEffects,
  ColorEffects,
  RuleEffects,
  CommentEffects,
  PlannerIdEffects,
  CountryEffects,
  ShippingTimeEffects,
  DepartmentEffects,
  ProductShipmentEffects,
  ProductArrivalEffects,
  FollowEffects,
  ProductEffects,
  ProductCountryEffects,
  SeasonEffects,
  UserEffects,
  FileEffects,
  ProviderEffects,
  NotificationEffects,
  PortEffects,
  MemberEffects,
  FollowShipmentEffects,
  HangerEffects,
  AlarmEffects,
  DestinationEffects,
  ProformaEffects,
  FollowGroupEffects,
  MilestoneEffects,
  ShippingmarksEffects,
  ReportsEffects,
  ShowroomEffects,
  CountryDepartmentEffects,
  LogsEffects,
  DestinationCenterEffects,
  UserBusinessEffects,
  JobEffects,
  SarEffects,
  ManagementEffects,
  PackagingEffects,
  PackagingManagerEffects,
  SustainabilityEffects,
  CoverEffects,
  ShipmentEffects,
  RetroplanningEffects,
  DepartmentFoodEffects,
  ColorBusinessEffects,
  DepartamentsBusinessColorEffects,
  FollowArrivalEffects,
  BriefEffects
];
